import { ModalContentWrapper } from "components/ModalContentWrapper";
import { FC } from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";

interface AddApiKeyFormData {
  name: string;
}

interface Props {
  register: UseFormRegister<AddApiKeyFormData>;
  errors: FieldErrors<AddApiKeyFormData>;
}

export const AddApiKeyModal: FC<Props> = ({ register, errors }) => {
  return (
    <ModalContentWrapper>
      <div className="pb-8">
        <label
          htmlFor="name"
          className="block text-sm font-medium text-gray-700"
        >
          Namn på API-nyckel
        </label>
        <input
          type="text"
          id="name"
          {...register("name", { required: "Namn måste anges" })}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
          placeholder="T.ex. Mitt affärssystem"
        />
        {errors.name && (
          <p className="mt-1 text-sm text-red-600">{errors.name.message}</p>
        )}
      </div>
    </ModalContentWrapper>
  );
};

export type { AddApiKeyFormData };
